import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroVideo.css';

function HeroVideo() {
    const navigate = useNavigate();
    const [videoVisible, setVideoVisible] = useState(false);

    const handleBuyClick = () => {
        navigate('/premium-strap');
    };
    const videoSrc = `${process.env.PUBLIC_URL || ''}/videos/hero-video.mp4`;

    return (
        <div className="hero-video-section">
            <video
                className={`hero-video ${videoVisible ? 'hero-video--visible' : ''}`}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                onLoadedData={() => setVideoVisible(true)}
            >
                <source src={videoSrc} type="video/mp4" />
            </video>
            <div className="hero-overlay">
                <div className="hero-content">
                    <h1 className="hero-title">Професионални Lifting Straps</h1>
                    <p className="hero-subtitle">За по-силни и по-безопасни тренировки за теб и твоя gym buddy.</p>
                    <div className="hero-trust-badges">
                        <span>131+ потвърдени покупки</span>
                        <span>4.7/5 оценка</span>
                        <span>Безплатна доставка при 2 или повече артикула, иначе доставка до 3.99 €</span>
                    </div>
                    <button type="button" className="hero-cta" onClick={handleBuyClick}>Купи сега - 19.99 €</button>
                </div>
            </div>
        </div>
    );
}

export default HeroVideo;
